
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductVariantsOptionModel } from './Entities.GormCrm.ProductVariantsOption';
import { VariantListModel } from './Entities.GormCrm.VariantList';
import { Model, ModelProperty } from 'models/Model';


export class VariantListOptionModel extends Model<VariantListOptionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'variantListOption.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'variantListOption.property.name' },
		{ name: 'variantListId', type: 'guid', languageString: 'variantListOption.property.variantListId' },
		{ name: 'deleted', type: 'Date', languageString: 'variantListOption.property.deleted', isHidden: true },
		{ name: 'productVariantsOptions', type: 'ProductVariantsOptionModel[]', languageString: 'variantListOption.property.productVariantsOptions', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductVariantsOptionModel }, properties: () => { return ProductVariantsOptionModel.classProperties } },
		{ name: 'variantList', type: 'VariantListModel', languageString: 'variantListOption.property.variantList', isHidden: true, isObject: true, new: () => { return new VariantListModel }, properties: () => { return VariantListModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public variantListId?: string;
	public deleted?: Date;
	public productVariantsOptions: ProductVariantsOptionModel[];
	public variantList?: VariantListModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.variantListId = undefined;
		this.deleted = undefined;
		this.productVariantsOptions = [];
		this.variantList = undefined;
		
	}
	getProperties(){
		return VariantListOptionModel.classProperties;
	}
}

